import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { energyBanner, energyStorageSolutions, solarEnergySolutions, windEnergySolutions } from 'images/expertise';
import DetailPage from 'containers/expertise/DetailPage';

const Energy: NextPage = () => {
  return (
    <>
      <Header
        title="Renewable Energy"
        description="We deploy the latest solutions and most comprehensive practices, keep abreast of current equipment, methods, and system developments. We deliver renewable energies that boast many advantages, these being abundant, clean, flexible, efficient, and competitive for natural environment."
        image={energyBanner}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: windEnergySolutions,
            title: 'Wind Energy Solutions',
            id: 'windEnergySolutions',
            hasListItems: true,
            textTitle: 'Comprehensive Wind Power Services',
            description:
              'We deliver end-to-end solutions for large-scale wind energy projects, focusing on innovation and reliability in every phase.',
            listItems: [
              { boldText: 'Planning & Authorization: ', text: 'Wind farm layout, yield analysis, regulatory approval' },
              { boldText: 'Grid Integration:', text: 'Design and execution of grid connections and transmission pathways' },
              { boldText: 'SWPPP & Compliance:', text: 'Stormwater management and compliance with environmental regulations' },
              { boldText: 'Construction & Installation:', text: 'Foundations, turbine setup, concrete work, electrical wiring' },
              { boldText: 'Engineering & Design:', text: 'Customized engineering for optimal energy production' },
              { boldText: 'Operations & Maintenance:', text: 'Full O&M services for turbines and infrastructure' },
              {
                boldText: 'Substation & Transmission Infrastructure:',
                text: 'Planning and construction of substations and grid connections',
              },
              { boldText: 'Specialized Equipment:', text: 'Installation of large platform turbines and custom configurations' },
            ],
          },
          {
            bgImage: solarEnergySolutions,
            title: 'Solar Energy Solutions',
            id: 'solarEnergySolutions',
            hasListItems: true,
            textTitle: 'Utility-Scale Solar Services',
            description:
              'Offering EPC (Engineering, Procurement, Construction) for large solar projects, ensuring seamless execution from start to finish.',
            listItems: [
              { boldText: 'Design & Planning:', text: 'Optimized site layout, energy production modeling, feasibility studies' },
              { boldText: 'Installation Types:', text: 'Ground-mounted, roof-mounted, and canopy-mounted solar systems' },
              { boldText: 'Integrated PV Solutions:', text: 'Solar installation in conjunction with existing structures' },
              { boldText: 'System Commissioning:', text: 'Comprehensive system testing and regulatory approval' },
              { boldText: 'Ongoing Maintenance:', text: 'DC and AC system upkeep, troubleshooting, and repairs' },
              { boldText: 'BOP (Balance of Plant) Procurement:', text: 'Full sourcing of all solar plant components' },
              { boldText: 'Performance Monitoring:', text: 'Real-time tracking of system efficiency and uptime' },
            ],
          },
          {
            bgImage: energyStorageSolutions,
            title: 'Energy Storage Solutions',
            id: 'energyStorageSolutions',
            hasListItems: true,
            textTitle: 'Battery Storage & Grid Stabilization',
            description: 'Our battery storage services support enhanced grid resilience and renewable energy consistency.',
            listItems: [
              { boldText: 'Storage System Design:', text: 'Tailored battery configurations to meet specific energy needs' },
              { boldText: 'Full-System Installation & Maintenance:', text: 'From integration to ongoing support and repairs' },
              { boldText: 'Project Commissioning:', text: 'Testing and grid connectivity optimization for battery systems' },
              {
                boldText: 'Hybrid Energy Integration:',
                text: 'Combined wind, solar, and storage solutions for energy stability',
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default Energy;
